(function (app) {
    app.provider("xrefAccountApi", [function () {
        this.$get = ["externalsApiGateway", function (externalsApiGateway) {
            var service = {};

            service.getAccounts = function (nextPageToken) {
                var url = "/Accounts/InSystem";

                if (nextPageToken)
                    url += "?nextPageToken=" + nextPageToken;

                return externalsApiGateway.getArray(url);
            };

            service.addAnnuities = function (accounts) {
                return externalsApiGateway.put("/Accounts/InSystem/Annuity", accounts);
            };

            service.addLife = function (accounts) {
                return externalsApiGateway.put("/Accounts/InSystem/Life", accounts);
            };

            service.addLongTermCare = function (accounts) {
                return externalsApiGateway.put("/Accounts/InSystem/LongTermCare", accounts);
            };

            service.addInvestments = function (accounts) {
                return externalsApiGateway.put("/Accounts/InSystem/Investment", accounts);
            };

            return service;
        }];
    }]);
})(window.app);